import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { VideoInfoModalComponent } from './video-info-modal.component';


export interface VideoInfoModalParams {
  title: string;
  description: string;
  callToAction?: string;
  videoId: string;
  footer?: {
    enabled: boolean;
    buttons: VideoInfoModalButtons[]
  };
}

export interface VideoInfoModalButtons {
  text: string;
  action: () => void;
  color: 'primary' | 'secundary';
}

@Injectable({
  providedIn: 'root'
})
export class VideoInfoModalService {
  constructor(private matDialog: MatDialog) {}

  public open({ title, description, callToAction, videoId, footer }: VideoInfoModalParams): Promise<void> {
    return this.matDialog.open(VideoInfoModalComponent, {
      data: { title, description, callToAction, videoId, footer }
    }).afterClosed()
      .toPromise();
  }

  public close(): void {
    this.matDialog.closeAll();
  }
}
